"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_intl_1 = require("react-intl");
var Icon_1 = __importDefault(require("../../Icon"));
var consts_1 = require("../consts");
var styles_1 = require("./styles");
var SidebarOpener = function (_a) {
    var handleOpenSidebar = _a.handleOpenSidebar, messages = _a.messages;
    var formatMessage = (0, react_intl_1.useIntl)().formatMessage;
    return ((0, jsx_runtime_1.jsx)(styles_1.Container, __assign({ onClick: handleOpenSidebar, "data-testid": consts_1.TEST_ID_MENU_OPENER, "aria-label": (messages === null || messages === void 0 ? void 0 : messages.expandSidebar) ? formatMessage(messages.expandSidebar) : 'Expand sidebar' }, { children: (0, jsx_runtime_1.jsx)(styles_1.OpenerIcon, { children: (0, jsx_runtime_1.jsx)(Icon_1.default, { name: "chevron-double-right" }) }) })));
};
exports.default = SidebarOpener;
